import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { SignupService } from 'src/app/services/signup/signup.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import Utils, { GetHelper, UtilsValidators, BrValidators } from 'src/app/helpers/utils';
import { LoadingService } from 'src/app/services/Loading/loading.service';
import { debounceTime } from 'rxjs/operators';
import { MaskPipe } from 'ngx-mask';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-dashboard-companies-group-details',
  templateUrl: './dashboard-companies-group-details.component.html',
  styleUrls: ['./dashboard-companies-group-details.component.scss'],
})
export class DashboardCompaniesGroupDetailsComponent implements OnInit {
  permissionObj = {
    canView: true,
    canAdd: true,
    canFilter: true,
    canInactive: true,
    canReset: true,
  };

  profilePermissionObj = {
    canView: true,
    canAdd: true,
    canFilter: true,
    canUnbound: true,
  };

  canViewDetails = true;
  canViewHistory = true;

  profilesData: any[] = [];
  usersData: any[] = [];

  filterForm = this.formBuilder.group({
    name: [null, []],
    document: [null, []],
    start_date: [
      null,
      [
        Utils.validateWhenNotEmpty(Utils.validateDateValid),
        Utils.validateWhenNotEmpty(Utils.validateMaxMinToday),
      ],
    ],
    end_date: [
      null,
      [
        Utils.validateWhenNotEmpty(Utils.validateDateValid),
        Utils.validateWhenNotEmpty(Utils.validateMaxMinToday),
      ],
    ],
  });

  form = this.formBuilder.group({
    name: [null, [Validators.required, UtilsValidators.fullName]],
    department: [null, [Validators.required]],
    email: [null, [Validators.required, UtilsValidators.email]],
    profile: [null, [Validators.required]],
    document: [null, [Validators.required, Validators.maxLength(14)]],
  });
  loadingDepartments = true;
  loadingProfiles = false;
  documentExists = true; // Começa TRUE - só libera se API confirmar que NÃO existe
  checkingDocument = false;

  usersLoading = true;
  profilesLoading = true;
  /**
   * Padrão de Filtros:
   * - hasFilters só deve ser true APÓS aplicar os filtros (método filterData())
   * - NÃO atualizar hasFilters no valueChanges do filterForm
   * - hasFilters deve ser atualizado apenas quando:
   *   1. filterData() executar com sucesso (após a requisição)
   *   2. resetForm() for chamado (define como false)
   *   3. toggleFilterModal() quando há filtros salvos no storage
   */
  hasFilters = false;
  appliedFilters: Array<{ label: string; value: string }> = [];
  showFilterModal = false;
  showUserModal = false;
  showProfilesFilterModal = false;
  isMaster = false;
  isSimple = false;
  acitveRegisterMasterUser = false;
  data: CompanyGroupValues = null;

  submiting = false;
  departmentOptions: SelectItem[] = [];

  profilesOffset: number = 0;
  profilesCount: number = 0;
  usersOffset: number = 0;
  usersCount: number = 0;
  loading = true;
  profileOptions: SelectItem[] = [];
  results_per_page;

  // Propriedades para os warning modals
  showBondModal = false;
  showStatusModal = false;
  showProfileStatusModal = false;
  showUserStatusModal = false;
  selectedBond: any = null;
  selectedProfile: any = null;
  selectedUser: any = null;
  isActive: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    private toast: ToastService,
    public signupService: SignupService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private maskPipe: MaskPipe,
    private breadcrumbService: BreadcrumbService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    if (
      !this.authService.verifyPermission(['de_can_view_company_groups_details'])
    ) {
      this.toast.show(
        'error',
        'Aviso',
        'Você não tem permissão para acessar essa página.'
      );
      this.router.navigateByUrl('/app/dashboard');
    }

    this.canViewDetails = this.authService.verifyPermission(
      'de_can_view_company_users_details'
    );
    this.canViewHistory = this.authService.verifyPermission(
      'de_can_view_company_users_history'
    );

    this.acitveRegisterMasterUser =
      this.authService.getPermissionType() === 'master';

    this.setBreadcrumb();
    this.setPermissions();
    this.getData();

    this.form.controls.department.valueChanges.subscribe((value) => {
      this.form.controls.profile.setValue(null);
      if (value) {
        this.getProfiles();
      } else {
        this.profileOptions = [];
      }
    });

    // Observar mudanças no documento para verificar se existe
    this.form.controls.document.valueChanges.pipe(debounceTime(500))
      .subscribe(async (value: any) => {
        const documentClean = value ? value.replace(/[^\d]+/g, '') : '';
        
        // SEMPRE reseta para TRUE ao mudar documento - campos NUNCA aparecem antes da API
        this.documentExists = true;
        
        // Quando o documento tem tamanho válido (apenas CPF - 11 dígitos)
        if (documentClean.length === 11) {
          this.checkingDocument = true;
          
          // Validar apenas CPF (11 dígitos)
          if (documentClean.length !== 11) {
            this.checkingDocument = false;
            this.documentExists = true;
            return;
          }
          
          const isValid = BrValidators.cpf(documentClean);
          
          if (!isValid) {
            // Documento inválido - mantém TRUE (não mostra campos)
            this.checkingDocument = false;
            this.documentExists = true;
            return;
          }
          
          // Chamar API para verificar se documento existe
          try {
            const res = await this.api.post({
              route: 'validate-user-paper-exists/',
              body: { document: documentClean },
              token: true,
            });
            
            this.checkingDocument = false;
            
            // Define documentExists baseado na resposta da API
            this.documentExists = res.exists === true;
            
            // SÓ mostra campos se documentExists === FALSE (não existe no sistema)
          } catch (error) {
            console.error('Erro ao validar documento:', error);
            this.checkingDocument = false;
            this.documentExists = true; // Erro = não mostra campos
          }
        } else {
          this.checkingDocument = false;
          this.documentExists = true; // Documento incompleto = não mostra campos
        }
      });
  }

  async getData() {
    await Promise.all([
      this.getUsersData(),
      this.getProfilesData(),
      this.getGroupData(),
    ]);
    await this.getDepartments();
  }

  async getDepartments() {
    try {
      const res = await this.api.get({
        route: 'api/v2/company_department/',
        token: true,
        params: {
          company: this.data.company_id,
        },
      });

      this.departmentOptions = res.map((item) => ({
        label: item.department,
        value: item.id,
      }));

      const findedDepartment =
        this.departmentOptions.find((item) => item.label === this.data.group)
          ?.value ?? null;

      this.form.controls.department.setValue(findedDepartment);
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }

    this.loadingDepartments = false;
  }

  async getGroupData() {
    try {
      const groupId = this.route.snapshot.params.groupId;
      const res = await this.api.get({
        route: `api/v2/user_group/${groupId}?type=view`,
        token: true,
      });

      this.data = res[0];
      this.setBreadcrumb(); // Atualizar breadcrumb após carregar os dados
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }

    this.loading = false;
  }

  async getUsersData(page: number = 1) {
    this.usersLoading = true;
    try {
      const groupId = this.route.snapshot.params.groupId;
      const filters: any = {};

      // Construir filtros a partir do formulário (se houver valores)
      const values = this.filterForm.value;
      Object.entries(values).forEach(([key, value]: any) => {
        if (value !== null && value !== '') {
          // Verificar se o campo tem erro de validação antes de incluir
          const control = this.filterForm.get(key);
          if (control && control.valid) {
            let newValue = value;
            if (key === 'start_date' || key === 'end_date') {
              newValue = value.split('/').reverse().join('-');
            }
            if (key === 'document') {
              newValue = value.replace(/[^\d]/g, '');
            }
            filters[key] = newValue;
          }
        }
      });

      if (filters['start_date'] && !filters['end_date']) {
        const atualDate = new Date().toISOString().split('T')[0];
        filters['end_date'] = atualDate;
      }

      if (filters['end_date'] && !filters['start_date']) {
        filters['start_date'] = '2000-01-01';
      }

      const { count, results, offset, results_per_page } = await this.api.get({
        route: `api/v2/user_group_user/`,
        token: true,
        params: { group: groupId, page: page, type: 'list', ...filters },
      });

      this.usersOffset = offset;
      this.usersCount = count;
      this.usersData = results;
      this.results_per_page = results_per_page;
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
    this.usersLoading = false;
  }

  async getProfilesData(page: number = 1) {
    try {
      const filters = {};

      if (this.hasFilters) {
        const values = this.filterForm.value;
        Object.entries(values).forEach(([key, value]: any) => {
          if (value !== null && value !== '') {
            filters[key] = value;
          }
        });
      }

      if (filters['start_date'] && !filters['end_date']) {
        const atualDate = new Date().toISOString().split('T')[0];
        filters['end_date'] = atualDate;
      }

      if (filters['end_date'] && !filters['start_date']) {
        filters['start_date'] = '2000-01-01';
      }

      const groupId = this.route.snapshot.params.groupId;

      const { count, users_type, offset } = await this.api.get({
        route: 'api/v2/user-profile-permission/',
        token: true,
        params: { page: page, group: groupId, type: 'list', ...filters },
      });

      this.profilesOffset = offset;
      this.profilesCount = count;
      this.profilesData = users_type;
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
    this.profilesLoading = false;
  }

  redirectToDetails(id: any) {
    const companyId = this.route.snapshot.params.id;
    this.router.navigateByUrl(
      `/app/permissions/companies/${companyId}/user/details/${id}`
    );
  }

  changePageData(page: number, isUsers: boolean = true) {
    if (isUsers) {
      this.usersLoading = true;
      this.getUsersData(page);
    } else {
      this.profilesLoading = true;
      this.getProfilesData(page);
    }
  }

  resetForm() {
    this.hasFilters = false;
    this.appliedFilters = [];
    this.filterForm.reset();

    // Se o modal de perfis está aberto, limpar filtros de perfis
    if (this.showProfilesFilterModal) {
      this.profilesLoading = true;
      this.getProfilesData();
    } else {
      // Caso contrário, sempre limpar filtros de usuários
      this.usersLoading = true;
      this.getUsersData();
    }
  }

  generateFilterTags(formValues: any) {
    this.appliedFilters = [];

    const fieldLabels: { [key: string]: string } = {
      name: 'Nome',
      document: 'CPF / CNPJ',
      start_date: 'Data inicial',
      end_date: 'Data final',
    };

    Object.entries(formValues).forEach(([key, value]: any) => {
      if (value !== null && value !== '' && value !== undefined) {
        let displayValue = value;

        // Tratamento especial para datas (já vem formatado do formulário)
        if (key === 'start_date' || key === 'end_date') {
          displayValue = value;
        }

        // Tratamento especial para CPF/CNPJ (já vem formatado do formulário)
        if (key === 'document') {
          displayValue = value;
        }

        if (fieldLabels[key]) {
          // Combinar label e valor no formato "label: valor"
          const combinedLabel = `${fieldLabels[key]}: ${String(displayValue)}`;
          this.appliedFilters.push({
            label: combinedLabel,
            value: String(displayValue),
          });
        }
      }
    });
  }

  toggleFilterModal() {
    this.showFilterModal = !this.showFilterModal;

    if (this.showFilterModal) {
      // Se houver filtros aplicados, restaurar no formulário
      if (this.hasFilters && this.appliedFilters.length > 0) {
        // Os valores já estão no formulário, apenas garantir que as tags estão atualizadas
        this.generateFilterTags(this.filterForm.value);
      } else {
        this.hasFilters = false;
        this.appliedFilters = [];
      }
    }
  }

  async filterData() {
    // Verificar se o formulário é válido antes de processar
    if (this.filterForm.invalid) {
      // Marcar todos os campos como touched para mostrar erros
      Object.keys(this.filterForm.controls).forEach((key) => {
        this.filterForm.get(key)?.markAsTouched();
      });
      return;
    }

    // Verificar qual modal está ativo - se showProfilesFilterModal está true, é perfis, senão é usuários
    const isProfilesFilter = this.showProfilesFilterModal;

    if (isProfilesFilter) {
      this.profilesLoading = true;
    } else {
      this.usersLoading = true;
    }

    try {
      const values = this.filterForm.value;
      const groupId = this.route.snapshot.params.groupId;

      const filters: any = {};

      Object.entries(values).forEach(([key, value]: any) => {
        if (value !== null && value !== '') {
          // Verificar se o campo tem erro de validação antes de incluir
          const control = this.filterForm.get(key);
          if (control && control.valid) {
            let newValue = value;
            if (key === 'start_date' || key === 'end_date') {
              newValue = value.split('/').reverse().join('-');
            }
            if (key === 'document') {
              newValue = value.replace(/[^\d]/g, '');
            }
            filters[key] = newValue;
          }
        }
      });

      if (filters['start_date'] && !filters['end_date']) {
        const atualDate = new Date().toISOString().split('T')[0];
        filters['end_date'] = atualDate;
      }

      if (filters['end_date'] && !filters['start_date']) {
        filters['start_date'] = '2000-01-01';
      }

      if (!isProfilesFilter) {
        const { results, count, offset } = await this.api.get({
          route: 'api/v2/user_group_user/',
          token: true,
          params: {
            page: 1,
            type: 'list',
            group: groupId,
            ...filters,
          },
        });

        // ✅ IMPORTANTE: hasFilters só é atualizado após aplicar os filtros com sucesso
        this.hasFilters = Object.keys(filters).length > 0;

        // ✅ Gerar as tags dos filtros aplicados
        this.generateFilterTags(values);

        this.usersCount = count;
        this.usersData = results;
        this.usersOffset = offset;
        this.showFilterModal = false;
      } else {
        // Filtro de perfis
        const { results, count, offset } = await this.api.get({
          route: 'api/v2/user-profile-permission/',
          token: true,
          params: {
            page: 1,
            type: 'list',
            group: groupId,
            ...filters,
          },
        });

        this.hasFilters = Object.keys(filters).length > 0;
        this.profilesCount = count;
        this.profilesData = results;
        this.profilesOffset = offset;
        this.showProfilesFilterModal = false;
      }
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
    this.usersLoading = false;
    this.profilesLoading = false;
  }

  setPermissions() {
    const permissions = Object.keys(this.permissionObj).map(
      (key) => `de_can_${key.split('can').join('').toLowerCase()}_company_users`
    );

    permissions.forEach((permission, idx) => {
      this.permissionObj[Object.keys(this.permissionObj)[idx]] =
        this.authService.verifyPermission(permission);
    });
  }

  setProfilesPermissions() {
    const permissions = Object.keys(this.profilePermissionObj).map(
      (key) =>
        `de_can_${key.split('can').join('').toLowerCase()}_company_profiles`
    );

    permissions.forEach((permission, idx) => {
      this.profilePermissionObj[Object.keys(this.profilePermissionObj)[idx]] =
        this.authService.verifyPermission(permission);
    });
  }

  redirectToGroupRegister() {
    const companyId = this.route.snapshot.params.id;
    const groupId = this.route.snapshot.params.groupId;
    this.router.navigateByUrl(
      `/app/permissions/companies/${companyId}/bond/group/${groupId}`
    );
  }

  renderUsersType(users_type: SelectItem[]) {
    return users_type.map((item) => item.label).join(', ');
  }

  handleCloseModal() {
    this.showProfilesFilterModal = false;
    this.showFilterModal = false;
    this.showUserModal = false;
    this.documentExists = true; // Reseta para TRUE
    this.checkingDocument = false;
    this.form.controls.profile.setValue(null);
    this.form.controls.name.setValue(null);
    this.form.controls.email.setValue(null);
    this.form.controls.document.setValue(null);
  }

  toggleBond(id: number) {
    this.selectedBond = { id };
    this.showBondModal = true;
  }

  async confirmBondRemoval() {
    try {
      const groupId = this.route.snapshot.params.groupId;

      const res = await this.api.patch({
        route: `api/v2/user-profile-permission/${this.selectedBond.id}/`,
        token: true,
        body: {
          group: [Number(groupId)],
          action: 'remove',
        },
      });

      this.showBondModal = false;
      this.getProfilesData();
    } catch (error) {
      console.error(error);
    }
  }

  closeBondModal() {
    this.showBondModal = false;
    this.selectedBond = null;
  }

  toggleUserModal() {
    this.showUserModal = !this.showUserModal;
    this.form.reset();
    this.documentExists = true; // Reseta para TRUE
    this.checkingDocument = false;

    if (this.showUserModal) {
      this.isSimple = true;
      this.isMaster = false;

      const findedDepartment =
        this.departmentOptions.find((item) => item.label === this.data.group)
          ?.value ?? null;

      this.form.controls.department.setValue(findedDepartment);
    }
  }

  async submit() {
    this.submiting = true;
    try {
      const valuesHelper = new GetHelper(this.form.value);

      const last_name = valuesHelper.get('name').split(' ').slice(1).join(' ');
      const collaboratorPayload: any = {
        email: valuesHelper.get('email'),
        first_name: valuesHelper.get('name').split(' ')[0],
        last_name,
        username: Utils.onlyNumbers(valuesHelper.get('document')),
        is_approver: this.isMaster,
        company: this.data.company_id,
        department: valuesHelper.get('department'),
        type_dispay:
          valuesHelper.get('document').length === 14
            ? 'Pessoa Jurídica'
            : 'Pessoa Física',
      };

      // Adiciona permission_profile apenas quando NÃO for master
      if (!this.isMaster && valuesHelper.get('profile')) {
        collaboratorPayload.permission_profile = valuesHelper.get('profile');
      }

      const payload = {
        username: Utils.onlyNumbers(valuesHelper.get('document')),
        simple_user: !this.isMaster,
        manager_user: this.isMaster,
        company: [this.route.snapshot.params.id],
        permission_group: this.route.snapshot.params.groupId
          ? [Number(this.route.snapshot.params.groupId)]
          : [],
        profiles: [valuesHelper.get('profile')],
        department: [valuesHelper.get('department')],
      };

      await this.api.post({
        route: 'api/collaborator/',
        token: true,
        body: collaboratorPayload,
      });

      await this.api.post({
        route: 'api/v2/user_group_user/',
        token: true,
        body: payload,
      });

      this.toast.show('info', 'Sucesso', 'Usuário cadastrado com sucesso.');

      this.usersLoading = true;
      this.showUserModal = false;
      this.form.reset();
      this.getUsersData();
      //   const data = {
      //     ...collaboratorPayload,
      //     ...payload,
      //   };
      //   this.resetPassword(data);
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao salvar os dados.');
    }
    this.submiting = false;
  }

  getDisabled() {
    return this.form.invalid || this.submiting;
  }

  async resetPassword(data) {
    try {
      await this.api.post({
        route: 'request-token/',
        body: {
          username: data.username,
          channel: 'email',
          reset: true,
        },
      });
    } catch (error) {}
  }

  toggleStatus() {
    this.isActive = this.data.status === 'Ativo';
    this.showStatusModal = true;
  }

  async confirmStatusChange() {
    try {
      const res = await this.api.patch({
        route: `api/v2/user_group/${this.data.id}/`,
        token: true,
        body: {
          status: this.data.status === 'Ativo' ? 'Inativo' : 'Ativo',
        },
      });

      this.loading = true;
      this.showStatusModal = false;
      this.getGroupData();
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao alterar o status do grupo.'
      );
    }
  }

  closeStatusModal() {
    this.showStatusModal = false;
    this.isActive = false;
  }

  toggleProfileStatus(id) {
    const findedProfile = this.profilesData.find((item) => item.id === id);
    this.selectedProfile = findedProfile;
    this.isActive = findedProfile.status === 'Ativo';
    this.showProfileStatusModal = true;
  }

  async confirmProfileStatusChange() {
    try {
      const groupId = this.route.snapshot.params.groupId;

      const res = await this.api.patch({
        route: `api/v2/user-profile-permission/${this.selectedProfile.id}/`,
        token: true,
        body: {
          group: [Number(groupId)],
          status: this.isActive ? 'Inativo' : 'Ativo',
        },
      });

      this.loading = true;
      this.showProfileStatusModal = false;
      this.getGroupData();
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao alterar o status do perfil de usuários.'
      );
    }
  }

  closeProfileStatusModal() {
    this.showProfileStatusModal = false;
    this.selectedProfile = null;
    this.isActive = false;
  }

  formatCpf(value: string) {
    const newValue = this.maskPipe.transform(value, '000.000.000-00');

    return newValue;
  }

  toggleUserStatus(id: number) {
    const findedUser = this.usersData.find((item) => item.id === id);
    this.selectedUser = findedUser;
    this.isActive = findedUser.status === 'Ativo';
    this.showUserStatusModal = true;
  }

  async confirmUserStatusChange() {
    try {
      const res = await this.api.patch({
        route: `api/v2/user_group_user/${this.selectedUser.id}/`,
        token: true,
        body: {
          status: this.selectedUser.status === 'Ativo' ? 'Inativo' : 'Ativo',
        },
      });

      this.usersLoading = true;
      this.showUserStatusModal = false;
      this.getUsersData();
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao alterar o status do usuário.'
      );
    }
  }

  closeUserStatusModal() {
    this.showUserStatusModal = false;
    this.selectedUser = null;
    this.isActive = false;
  }

  // Funções auxiliares para os modais
  getBondModalTitle(): string {
    return 'Remover vínculo';
  }

  getBondModalMessage(): string {
    return 'Deseja remover esse vínculo? Essa ação não poderá ser desfeita.';
  }

  getBondConfirmText(): string {
    return 'Sim, remover vínculo';
  }

  getStatusModalTitle(): string {
    return this.isActive ? 'Inativar grupo' : 'Ativar grupo';
  }

  getStatusModalMessage(): string {
    return `Deseja ${
      this.isActive ? 'inativar' : 'ativar'
    } esse grupo? Todas as permissões vinculadas a esse grupo também serão afetadas.`;
  }

  getStatusConfirmText(): string {
    return `Sim, ${this.isActive ? 'inativar' : 'ativar'} grupo`;
  }

  getProfileStatusModalTitle(): string {
    return this.isActive ? 'Inativar perfil' : 'Ativar perfil';
  }

  getProfileStatusModalMessage(): string {
    return `Deseja ${
      this.isActive ? 'inativar' : 'ativar'
    } esse perfil? Todas as permissões vinculadas a esse perfil também serão afetadas.`;
  }

  getProfileStatusConfirmText(): string {
    return `Sim, ${this.isActive ? 'inativar' : 'ativar'} perfil`;
  }

  getUserStatusModalTitle(): string {
    return this.isActive ? 'Inativar usuário' : 'Ativar usuário';
  }

  getUserStatusModalMessage(): string {
    return `Deseja ${
      this.isActive ? 'inativar' : 'ativar'
    } esse usuário? Todas as permissões vinculadas a esse usuário também serão afetadas.`;
  }

  getUserStatusConfirmText(): string {
    return `Sim, ${this.isActive ? 'inativar' : 'ativar'} usuário`;
  }

  renderProfileName(item) {
    const labels = item.map((i) => i.permission);

    return labels.join(', ');
  }

  formatGroups(groups: string[]) {
    if (groups.length > 3) {
      const rest = groups.length - 3;
      return `${groups.slice(0, 3).join(', ')} +${rest}`;
    }
    return groups.join(', ');
  }

  handleChangeValue(type: string) {
    // Método mantido para compatibilidade, mas não é mais usado
    // Sempre mantém como usuário comum
    this.isSimple = true;
    this.isMaster = false;
  }

  async getProfiles() {
    this.loadingProfiles = true;
    this.loadingService.show('Carregando perfis de acesso...');
    try {
      const id = this.route.snapshot.paramMap.get('id');

      let params: any = {
        tab: 'user_profile',
      };

      if (this.isMaster) {
        params = {
          ...params,
          master_user: true,
        };
      }

      if (this.isSimple) {
        params = {
          ...params,
          default_user: true,
        };
      }

      if (this.form.value.department) {
        params = {
          ...params,
          department: this.form.value.department,
        };
      }

      if (
        this.form.value.department === null ||
        this.form.value.department === undefined
      ) {
        this.loadingProfiles = false;
        return;
      }

      const res = await this.api.get({
        route: `api/v3/companies/${id}/`,
        params,
        token: true,
      });

      // V3 sempre retorna paginação
      const profiles = res.results || res;
      this.profileOptions = profiles.map((item) => ({
        label: item.description,
        value: item.id,
        extra: item.id,
      }));
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    } finally {
      this.loadingProfiles = false;
      this.loading = false;
      this.loadingService.hide();
    }
  }

  setBreadcrumb(): void {
    const canViewCompanies = this.authService.verifyPermission(
      'de_can_view_companies'
    );
    const companyId = this.route.snapshot.params.id;
    const groupId = this.route.snapshot.params.groupId;
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Empresas',
        url: '/app/permissions/companies',
        clickable: canViewCompanies,
      },
      {
        label: 'Detalhes da empresa',
        url: `/app/permissions/companies/details/${companyId}`,
        clickable: canViewCompanies,
      },
      {
        label: 'Detalhes do grupo',
        url: `/app/permissions/companies/${companyId}/group/details/${groupId}`,
        clickable: false, // Página atual, não precisa ser clicável
      },
    ];
    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }

  /**
   * Verifica se os filtros podem ser aplicados
   * Retorna false se houver campos inválidos ou se não houver nenhum filtro preenchido
   */
  get canApplyFilters(): boolean {
    // Verifica se o formulário é válido
    if (this.filterForm.invalid) {
      return false;
    }

    // Verifica se há pelo menos um filtro preenchido
    const values = this.filterForm.value;
    const hasAnyFilter = Object.values(values).some(
      (value) => value !== null && value !== '' && value !== undefined
    );

    return hasAnyFilter;
  }
}
